import * as React from "../_snowpack/pkg/react.js";
import {format, formatDuration} from "./date-helpers.js";
import {DateExpression, Result, Box} from "./Style.js";
export const ResultBox = ({startDate, resultDate, duration}) => {
  const formattedDuration = formatDuration(duration || {}) || "chwila";
  return /* @__PURE__ */ React.createElement(Box, {
    p: 2,
    borderWidth: "1px",
    borderRadius: "sm",
    width: "100%"
  }, /* @__PURE__ */ React.createElement(DateExpression, null, formattedDuration, " od ", format(startDate, "do MMMM yyyy"), " to"), /* @__PURE__ */ React.createElement(Result, {
    "aria-label": "Result"
  }, format(resultDate, "do MMMM yyyy")));
};
